import React from 'react';

import { LockSvg } from 'pages/common/components/svgs/LockSvg';

import { SecureText, SecureWrapper } from './SecureBadge-styled-components';

export const SecureBadge = () => (
  <SecureWrapper>
    <LockSvg />
    <SecureText>Secure</SecureText>
  </SecureWrapper>
);
